import ModelService from './ModelService';
const modelService = new ModelService();

const model = 'purchase-code-brands';

export async function IndexPurchaseCodeBrand() {
  return modelService.IndexModel(model);
}
